import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, catchError, exhaustMap } from 'rxjs/operators';

import { UserInformationService } from '@core/store/services/user-information.service';
import * as userInformationActions from '@core/store/actions/user-information.actions';
import { ActionTypes } from '@core/store/actions';
import * as actions from '@core/store/actions/user-information.actions';
import { of } from 'rxjs';


@Injectable()
export class UserInformationEffects {
  constructor(private userInformationService: UserInformationService, private actions$: Actions) {}

  loadUserInformations$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ActionTypes.LoadUserInformation),
      exhaustMap(action => {
        return this.userInformationService.getUserInformations().pipe(
          map(userInformation => new userInformationActions.LoadUserInformationSuccess(userInformation)),
          catchError(error => of(new userInformationActions.LoadUserInformationFail(error)))
        );
      })
    );
  });

  setInformationAsRead$ = createEffect(() => {
    return   this.actions$.pipe(
      ofType(ActionTypes.InformationSetAsRead),
      map((action: actions.InformationSetAsRead) => action.payload),
      exhaustMap(guideId => {
        return this.userInformationService.setInformationAsRead(guideId).pipe(
          map(result => new actions.InformationSetAsReadSuccess(result)),
          catchError(error => of(new actions.InformationSetAsReadFail(error)))
        );
      })
    );
  });
}
